<template>
  <component
    :is="getContainerType"
    v-if="shouldRenderConfig"
    :class="getClassName"
  >
    <appPageOption
      v-for="(pageOption, key, index) in getPageOptions"
      :key="getSelector + ' ' + index"
      :code="key"
      :index="index"
      :propsData="pageOption"
      :ppcode="ppcode"
    ></appPageOption>
  </component>
</template>
<script>
import { mapState, mapActions } from "pinia";

import { useWebproductStore } from "@/stores/modules/webproduct";

export default {
  computed: {
    ...mapState(useWebproductStore, [
      "getActiveProductPageOptions",
      "getSelector",
      "getProductPageOptionsForCode"
    ]),
    getPageOptions: function () {
      if (this.ppcode) {
        return this.getProductPageOptionsForCode({ code: this.ppcode });
      }
      return this.getActiveProductPageOptions;
    }
  },
  props: ["hideContainer", "ppcode"]
};
</script>
